import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { VendorDetailActions } from "stores/VendorDetailsStore/VendorDetailAction";

const mapStateToProps = (state) => {
  return {

    VendorDetailList:state.Vendordetail.VendorDetailList
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

  getVendorDetailsAction:VendorDetailActions.getVendorDetail
}, dispatch);

const RequestDetailsStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default RequestDetailsStore;
